import { HttpClient } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Pipe({ name: 'resource' })
export class ResourcePipe implements PipeTransform {

  constructor(private http: HttpClient, private sanitizer: DomSanitizer) {}

  async transform(obj: any, type?: any, location?: any): Promise<SafeUrl> {
    if (type == 'LOCAL') {
      return new Promise((resolve, reject) => {resolve(obj)});
    } else {
      const src: string = `${environment.url.resource}/${location}/${obj}`;
      const resource = await this.http.get(src, {responseType: 'blob'}).toPromise();
      const reader = new FileReader();
      return new Promise((resolve, reject) => {
        reader.onloadend = () => resolve(this.sanitizer.bypassSecurityTrustUrl(reader.result as string));
        reader.readAsDataURL(resource);
      });
    }
  }
}
